import { useEffect, useCallback, useRef, memo } from 'react'
import PropTypes from 'prop-types'

import * as S from './styled'

const BASE_YOUTUBE_URL = 'https://www.youtube.com/embed'
const DEFAULT_QUERY_STRING =
  'showinfo=0&rel=0&fs=1&enablejsapi=1&modestbranding=1'

const YoutubePlayer = ({ previewSrc, previewAlt, videoId, isCurrentSlide }) => {
  const playerRef = useRef()

  const url = `${BASE_YOUTUBE_URL}/${videoId}?${DEFAULT_QUERY_STRING}`

  const stopVideo = useCallback((player) => {
    const message = JSON.stringify({
      event: 'command',
      func: 'stopVideo',
      args: ''
    })

    return player.contentWindow.postMessage(message, '*')
  }, [])

  useEffect(() => {
    const player = playerRef.current

    if (!isCurrentSlide && player) {
      stopVideo(player)
    }
  }, [isCurrentSlide, stopVideo])

  return (
    <S.YoutubePlayer>
      <img src={previewSrc} alt={previewAlt} />
      <iframe
        ref={playerRef}
        frameBorder="0"
        allowFullScreen="allowfullscreen"
        src={url}
      />
    </S.YoutubePlayer>
  )
}

YoutubePlayer.propTypes = {
  previewSrc: PropTypes.string,
  previewAlt: PropTypes.string,
  videoId: PropTypes.string.isRequired,
  isCurrentSlide: PropTypes.bool.isRequired
}

export default memo(YoutubePlayer)
